import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfiguracaoNfRoutingModule } from './configuracao-nf-routing.module';
import { ConfiguracaoNfComponent } from './configuracao-nf.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [ConfiguracaoNfComponent],
  imports: [
    CommonModule,
    ConfiguracaoNfRoutingModule,
    SharedModule]
})
export class ConfiguracaoNfModule { }
